import { PackagesAppController } from '../controller/PackagesAppController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class PackagesAppWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PackagesAppController,
    });
  }
}
